<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
		'data-cy'?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} fill="none" {...rest}>
	<path
		d="M15.4669 15.1032L20.3638 20M6.23635 5.87256C7.48473 4.62418 9.12093 3.99999 10.7571 4C12.3933 4.00001 14.0295 4.62421 15.2779 5.87259C16.5263 7.12098 17.1505 8.75718 17.1505 10.3934C17.1505 12.0296 16.5263 13.6658 15.2779 14.9141C14.0296 16.1625 12.3934 16.7867 10.7571 16.7867C9.12094 16.7867 7.48473 16.1625 6.23635 14.9141C4.98796 13.6658 4.36377 12.0296 4.36377 10.3934C4.36377 8.75715 4.98796 7.12094 6.23635 5.87256Z"
		stroke={getTailwindColor(color)}
		stroke-linecap="round"
	/>
</SvgWrapper>
